import { Button, Col, Form, Row } from "react-bootstrap"
import { Typography } from "../../components/utilities/Typhograpy"
import { useForm } from "react-hook-form";
import { getUserInfo, updatePaidLeave } from "../../api/UsersApi";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import GlobalContext from "../../context/GlobalContext";
import BoxSkeleton from "../../components/utilities/BoxSkeleton";
import BackButton from "../../components/button/BackButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import swal from "../../services/swalConfig";


import { tr } from "../../i18n";
const UsersEditPaidLeave = () => {
    const isMounted = useRef(true) 
    const location = useLocation();
    const personnelId = location.state?.personnel_id || null;
    const [personelData,setPersonelData] = useState(null)
    const {user,setLoading} = useContext(GlobalContext)
    const {register,handleSubmit,formState:{errors},setError} = useForm();

    const loadPersonnelInformation = async () => {
        setPersonelData(null)

        try {    

            const response = await getUserInfo(personnelId);

            if(response.status == 200){
                setPersonelData(response.data);
            }else if(response.status == 404){
                setPersonelData([]);
            }

        } catch (error) {
            setPersonelData(null)
        }
    }

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }

        loadPersonnelInformation();
    }, [user]);

    return (
        <Row>
            <Col lg={6}>
                <div className="box-shadow">

                    {personelData == null ? (
                        <BoxSkeleton count="6" size="12" height="20px" />
                    ) : (
                        <Form onSubmit={handleSubmit(async (data) => {

                            try {
                                setLoading(true)

                                const newData = {
                                    'company_id': user.workspace.company_id,
                                    'personnel_id': personnelId,
                                    'paid_leave': data.paid_leave
                                };

                                const response = await updatePaidLeave(newData);

                                response.status === 400
                                ? Object.entries(response.errors).forEach(([key, message]) => 
                                    setError(key, { type: 'manual', message })
                                )
                                : swal.fire({
                                    title: response.status === 200 ? tr("users:congratulations") : tr("common:errors.oops"),
                                    text: response.message,
                                    icon: response.status === 200 ? 'success' : 'error',
                                    showCancelButton: false
                                });


                            } catch (error) {
                                swal.fire({
                                    title: tr("common:errors.oops"),
                                    text: tr("users:something_wrong_try_logging_in_later"),
                                    icon: 'error',
                                    showCancelButton: false
                                });
                            }finally{
                                setLoading(false)
                            }

                        })}>
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label column sm="3">
                                    <Typography variant="form">{tr("users:id")}</Typography>
                                </Form.Label>
                                <Col sm="9">
                                    <Form.Control 
                                        plaintext 
                                        readOnly 
                                        defaultValue={personelData.internal_id || "-"} 
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label column sm="3">
                                    <Typography variant="form">{tr("shared:name")}</Typography>
                                </Form.Label>
                                <Col sm="9">
                                    <Form.Control 
                                        plaintext 
                                        readOnly 
                                        defaultValue={personelData.personal_name} 
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="3">
                                    <Typography variant="form">{tr("common:breadcrumb.paid-leave")}</Typography>
                                </Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        {...register("paid_leave")}
                                        type="number"
                                        placeholder={tr("common:breadcrumb.paid-leave")}
                                        defaultValue={personelData.internal_paid_leave || 0}
                                        style={{width:"80px"}}
                                        className="text-end mb-2"
                                    />
                                    <Typography variant="caption" style={{overflow:"unset",whiteSpace:"unset"}}>{tr("users:paid_leave_adjusts_based_on_your")}</Typography>
                                    {errors.paid_leave && (
                                        <small className="text-danger">{errors.paid_leave.message}</small>
                                    )}
                                </Col>
                                <Col lg={12} md={12} sm={12} className="mt-3 d-flex justify-content-between mt-5">
                                    <BackButton params={{personnel_id:personnelId}}/>
                                    <Button type="submit" className="btn btn-primary">
                                        <FontAwesomeIcon icon={faCheckCircle} /> {" "}{tr("users:update_paid_leave")}
                                    </Button>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </div>
            </Col>
        </Row>
    );    

}

export default UsersEditPaidLeave